/**
 * <footer-accordion>
 * Collapses a footer link-list block on small screens.
 * Desktop (>= 990px): panel is always visible and the trigger is disabled.
 * Mobile/tablet: trigger toggles the panel via `is-open` + aria-expanded.
 */
const FOOTER_DESKTOP_QUERY = '(min-width: 990px)';

class FooterAccordion extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-footer-accordion-trigger]');
    this.panel = this.querySelector('[data-footer-accordion-panel]');
    if (!this.trigger || !this.panel) return;

    this.handleClick = this.handleClick.bind(this);
    this.syncWithViewport = this.syncWithViewport.bind(this);

    this.mediaQuery = window.matchMedia(FOOTER_DESKTOP_QUERY);
    this.mediaQuery.addEventListener('change', this.syncWithViewport);
    this.addEventListener('click', this.handleClick);

    this.syncWithViewport();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.mediaQuery?.removeEventListener('change', this.syncWithViewport);
  }

  get isOpen() {
    return this.trigger.getAttribute('aria-expanded') === 'true';
  }

  handleClick(event) {
    const trigger = event.target.closest('[data-footer-accordion-trigger]');
    if (!trigger || this.mediaQuery.matches) return;
    this.setOpen(!this.isOpen);
  }

  setOpen(open) {
    this.trigger.setAttribute('aria-expanded', String(open));
    this.classList.toggle('is-open', open);
  }

  syncWithViewport() {
    const isDesktop = this.mediaQuery.matches;
    this.trigger.toggleAttribute('disabled', isDesktop);
    this.trigger.setAttribute('aria-expanded', String(isDesktop || this.classList.contains('is-open')));
  }
}

if (!customElements.get('footer-accordion')) {
  customElements.define('footer-accordion', FooterAccordion);
}
